<div class="validation-source-container">
  <div class="validation-source-header">
    <div class="title">Select Validation Value</div>
    <div class="close-icon" style="cursor: pointer;" (click)="cancel()"><mat-icon>close</mat-icon></div>
  </div>
  <div class="validation-source-body">
    <div style="margin-bottom: 12px;">Choose the validation you want to confirm for this value.</div>
    <mat-radio-group [(ngModel)]="selectedSource" [disabled]="radiosDisabled || userTypedManual" style="display:flex; flex-direction:row; gap:16px; align-items:center;">
      <span [matTooltip]="tooltipText" matTooltipPosition="above" [matTooltipDisabled]="!(radiosDisabled || userTypedManual)" style="display:inline-flex; align-items:center;">
        <mat-radio-button value="TAPE" disableRipple [disabled]="radiosDisabled || userTypedManual"> Tape Value </mat-radio-button>
      </span>
      <span [matTooltip]="tooltipText" matTooltipPosition="above" [matTooltipDisabled]="!(radiosDisabled || userTypedManual)" style="display:inline-flex; align-items:center;">
        <mat-radio-button value="SOURCE" disableRipple [disabled]="radiosDisabled || userTypedManual"> Source Value </mat-radio-button>
      </span>
    </mat-radio-group>
    <div style="margin-top:12px;">
      <div class="note-label">Manual Input</div>
      <input type="text" [(ngModel)]="userNote" (ngModelChange)="onUserNoteChange($event)" class="note-textarea" />
    </div>
    <div style="margin-top: 16px; display:flex; gap:8px; justify-content:flex-end;">
      <button mat-button disableRipple class="validation-button button-light" (click)="cancel()">Cancel</button>
      <button mat-button class="validation-button button-dark" [ngClass]="{'disabled': !canSubmit}" (click)="confirm()" [disabled]="!canSubmit">Confirm</button>
    </div>
  </div>
</div>
